import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

export const MasterQuantityList = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  async function fetchcommodity()
  {
    let commoditylist = await sendNetworkRequest('/fetchmasterquantity', {}, {},false)
    setOrders(commoditylist)
  }
  useEffect(() => {
    fetchcommodity()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      {/* <SearchBar /> */}
      <Results
        className={classes.results}
        orders={orders} //
      /> 
     
    </Page>
  );
});

export default MasterQuantityList;
